import { SWRConfig, SWRConfiguration } from "swr";
import React, { useContext, useMemo } from "react";
import { TokenContext } from "./TokenContext";
import { swrFetcher } from "../services/queries";
import { TenantContext } from "./TenantContextProvider";
import { useAuth0 } from "@auth0/auth0-react";

export function SWRConfigProvider({ children }: { children?: React.ReactNode }) {
  const { logout } = useAuth0();
  const { token } = useContext(TokenContext);
  const { tenant } = useContext(TenantContext);

  const value = useMemo<SWRConfiguration>(
    () => ({
      fetcher: (input: RequestInfo, init?: RequestInit) => {
        const { method, headers, ...restInit } = init ?? {};

        return swrFetcher(input, {
          ...restInit,
          method,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            ...(tenant ? { "Business-Tenant": tenant } : {}),
            ...headers,
          },
        });
      },
      onError: (error) => {
        if (error.message === "Unauthorized") {
          logout({ logoutParams: { returnTo: `${window.location.origin}/taskpane.html` } });
        }
      },
      errorRetryCount: 3,
      errorRetryInterval: 5000,
      shouldRetryOnError: (error) => {
        if (error?.status >= 400 && error?.status < 500 && error?.status !== 429) {
          return false;
        }
        // Retry on network errors and 5xx server errors
        return true;
      },
    }),
    [token, tenant, logout]
  );

  return <SWRConfig value={value}>{children}</SWRConfig>;
}
